module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"listeningMsg":"I am listening...","introSpeech":"Hi, I\u0027m here to help. Please tap on the microphone button on the upper right and ask me your question."},"es":{"listeningMsg":"Estoy escuchando...","introSpeech":"Hola, estoy aquí para ayudarlo. Toque el botón de micrófono en la parte superior derecha y hágame su pregunta."}}')
  delete Component.options._Ctor
}
